// src/components/RecommendedCarsSlider.tsx
"use client";

import React, { useState } from "react";
import CustomSlider from "@/component/ui/CustomSlider/CustomSlider";
import CardSkeleton from "./CardSkeleton";

// import CarCard from "./CarCard";
// import CarCardSkeleton from "./CarCardSkeleton";
import CarCard from "./ProductCard";

interface Car {
    _id: string;
    name: string;
    slug: string;
    brand_name: string;
    brand_slug: string;
    featured_image?: string;
    price_range: {
        base: number;
        top: number;
    };
    engine_displacement: string;
    fuel_type: string;
    base_variant: any;
}

interface RecommendedCarsSliderProps {
    data?: Car[];
    title?: string;
    isLoading?: boolean;
    skeletonCount?: number;
}

export default function RecommendedCarsSlider({
    data,
    title = "Recommended Cars",
    isLoading = false,
    skeletonCount = 6,
}: RecommendedCarsSliderProps) {
    const cars = data && data.length > 0 ? data : [];

    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);

    const showNavigation = !isLoading && cars.length > 3;

    return (
        <section className="mb-8 md:mb-12">
            <h2 className="text-[20px] md:text-[24px] font-bold leading-[36px] mb-2">
                {title}
            </h2>
            <p className="text-[14px] leading-[24px] text-gray-600 mb-6">
                Compare popular cars in similar price range
            </p>

            <div className="relative">
                {/* Navigation handled by CustomSlider arrows when enabled */}

                <CustomSlider
                    responsive={{ mobile: 1, tablet: 2, desktop: 3 }}
                    gap={16}
                    showArrows={showNavigation}
                    onSlideChange={(idx) => {
                        setIsAtStart(idx === 0);
                        setIsAtEnd(idx >= Math.max(cars.length - 3, 0));
                    }}
                >
                    {isLoading || cars.length === 0
                        ? Array(skeletonCount)
                            .fill(null)
                            .map((_, index) => (
                                <div key={`skeleton-${index}`}>
                                    <CardSkeleton />
                                </div>
                            ))
                        : cars.map((car) => (
                            <div key={car._id}>
                                <CarCard car={car} />
                            </div>
                        ))}
                </CustomSlider>
            </div>
        </section>
    );
}